import { useExamCenter } from '@exam-center/exam-center-details';
import { ExamCenterMemberDetailsModal } from '@exam-center/exam-center-member-details';
import { useGetExamCenterMembersByExamCenterCodeQuery } from '@exam-center/graphql';
import { type GridCellParams } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useMemo, useState } from 'react';

import { BaseExamCenterMemberDataGrid, ExamCenterMemberListNoRowsOverlay } from '../../components';
import { mapExamCenterMemberData } from '../../utils';

import { columns, type ExamCenterMemberListItem } from './columns';

export default function ExamCenterMemberList() {
  const { examCenter } = useExamCenter();
  const { code: examCenterCode } = examCenter;

  const [isMemberDetailsModalOpen, memberDetailsModalHandlers] = useDisclosure();
  const { open: openMemberDetailsModal, close: closeMemberDetailsModal } =
    memberDetailsModalHandlers;

  const [examCenterMemberId, setExamCenterMemberId] = useState('');

  const { data: membersData, loading: isLoading } = useGetExamCenterMembersByExamCenterCodeQuery({
    variables: {
      getExamCenterMembersByExamCenterCodeInput: {
        examCenterCode: examCenterCode,
      },
    },
  });

  const members = useMemo(() => {
    return (
      membersData?.ecGetExamCenterMembersByExamCenterCode.examCenterMembers.map((member, index) =>
        mapExamCenterMemberData(member, index + 1),
      ) ?? []
    );
  }, [membersData]);

  const handleClickMemberRow = (params: GridCellParams<ExamCenterMemberListItem>) => {
    setExamCenterMemberId(params.row.id);
    openMemberDetailsModal();
  };

  return (
    <>
      <BaseExamCenterMemberDataGrid
        columns={columns}
        rows={members}
        loading={isLoading}
        onCellClick={handleClickMemberRow}
        slots={{
          noRowsOverlay: ExamCenterMemberListNoRowsOverlay,
        }}
      />
      <ExamCenterMemberDetailsModal
        open={isMemberDetailsModalOpen}
        onClose={closeMemberDetailsModal}
        examCenterMemberId={examCenterMemberId}
      />
    </>
  );
}
